import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const DISMISS_KEY = "prp_install_dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = setTimeout(() => { if (isIos()) { setIos(true); setShow(true); } }, 4000);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); clearTimeout(t); };
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-md rounded-2xl border border-slate-200 bg-white p-4 shadow-xl sm:inset-x-auto sm:right-4" data-testid="install-prompt" style={{ paddingBottom: "max(1rem, env(safe-area-inset-bottom))" }}>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="install-dismiss" className="absolute right-2 top-2 rounded-md p-1.5 text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>
      <div className="flex items-start gap-3">
        <img src="/logo192.png" alt="" className="h-11 w-11 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="font-heading text-sm font-semibold text-slate-900">Add PR Pathfinder to your home screen</p>
          {ios ? (
            <p className="mt-1 text-xs text-slate-600">Tap <Share className="inline h-3.5 w-3.5 align-text-bottom" /> <strong>Share</strong> in Safari, then <strong>Add to Home Screen</strong>.</p>
          ) : (
            <p className="mt-1 text-xs text-slate-600">Quick access to your scores and draw alerts, full-screen like an app.</p>
          )}
          {!ios && (
            <button onClick={install} data-testid="install-btn" className="mt-3 inline-flex min-h-[40px] items-center gap-1.5 rounded-md bg-[#C8102E] px-4 text-sm font-semibold text-white hover:bg-[#A60C24]">
              <Download className="h-4 w-4" /> Install app
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
